// my-loader.component.ts
import { Component, OnInit, inject } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { delay } from 'rxjs';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
    selector: 'app-my-loader',
    templateUrl: './my-loader.component.html',
    styleUrls: ['./my-loader.component.scss'],
    imports: [MatProgressBar]
})
export class MyLoaderComponent implements OnInit {
  private loaderService = inject(LoaderService);

  loading: boolean;

  ngOnInit() {
    this.loaderService.isLoading
      .pipe(delay(0))
      .subscribe((loading) => {
        this.loading = loading;
      });
  }

}
